const jsonURLTotal = {
  CA_MOIS_SUR_ANNEE: "update_ca_ht_et_ttc_par_mois_sur_annee",
  CA_QUART_SUR_AUJOURDHUI: "update_ca_ht_et_ttc_par_quart_sur_aujourdhui",
  CA_JOUR_SUR_SEMAINE: "update_ca_ht_et_ttc_par_jour_sur_semaine",
  CA_JOUR_SUR_MOIS: "update_ca_ht_et_ttc_par_jour_sur_mois",
  CA_QUART_SUR_JOUR: "update_ca_ht_et_ttc_par_quart_sur_aujourdhui",

  CA_HIER: "update_ca_ht_et_ttc_sur_hier",
  CA_AUJOURDHUI: "update_ca_ht_et_ttc_sur_aujourdhui",
  CA_ANNEE: "update_ca_ht_et_ttc_sur_annee",
  CA_MOIS: "update_ca_ht_et_ttc_sur_mois",
  CA_SEMAINE: "update_ca_ht_et_ttc_sur_semaine",
  CA_DYNAMIQUE_HIER: "update_ca_ht_et_ttc_dynamique_sur_hier",
  CA_DYNAMIQUE_MEME_JOUR_SP:
    "update_ca_ht_et_ttc_dynamique_sur_meme_jour_semaine_precedente",

  CA_ANNEE_PRECEDENTE: "update_ca_ht_et_ttc_sur_annee_precedente",
  CA_MOIS_PRECEDENT: "update_ca_ht_et_ttc_sur_mois_precedent",
  CA_MOIS_ANNEE_PRECEDENTE: "update_ca_ht_et_ttc_sur_mois_annee_precedente",
  CA_SEMAINE_PRECEDENTE: "update_ca_ht_et_ttc_sur_semaine_precedente",
  CA_SEMAINE_ANNEE_PRECEDENTE:
    "update_ca_ht_et_ttc_sur_semaine_annee_precedente",

  VENTE_ART_JOUR_PAR_EQUIPEMENT: "vente_par_articles_sur_jour_par_equipement",
  VENTE_ART_MOIS_PAR_EQUIPEMENT: "vente_par_articles_sur_mois_par_equipement",
  VENTE_ART_ANNEE_PAR_EQUIPEMENT: "vente_par_articles_sur_annee_par_equipement",

  // UPDATE PRESTA

  PRESTA_MOIS_SUR_ANNEE: "update_presta_par_mois_sur_annee",
  // PRESTA_JOUR_SUR_SEMAINE: "update_presta_par_jour_sur_semaine",
  PRESTA_JOUR_SUR_MOIS: "update_presta_par_jour_sur_mois",
  PRESTA_QUART_SUR_JOUR: "update_presta_par_quart_sur_aujourdhui",

  PRESTA_QUART_SUR_JOUR_PAR_EQUIPEMENT:
    "update_presta_par_quart_sur_aujourdhui_par_equipement",
  PRESTA_QUART_SUR_MOIS_PAR_EQUIPEMENT:
    "update_presta_par_quart_sur_mois_par_equipement",
  PRESTA_QUART_SUR_ANNEE_PAR_EQUIPEMENT:
    "update_presta_par_quart_sur_annee_par_equipement",

  PRESTA_QUART_SUR_MOIS: "update_presta_par_quart_sur_mois",

  PRESTA_HIER: "update_presta_sur_hier",
  PRESTA_AUJOURDHUI: "update_presta_sur_aujourdhui",
  PRESTA_ANNEE: "update_presta_sur_annee",
  PRESTA_MOIS: "update_presta_sur_mois",
  PRESTA_SEMAINE: "update_presta_sur_semaine",
  PRESTA_DYNAMIQUE_HIER: "update_presta_dynamique_sur_hier",
  PRESTA_DYNAMIQUE_MEME_JOUR_SP:
    "update_presta_dynamique_sur_meme_jour_semaine_precedente",
  PRESTA_DYNAMIQUE_MEME_JOUR_MP:
    "update_ca_ht_et_ttc_dynamique_sur_meme_jour_mois_precedent",

  PRESTA_ANNEE_PRECEDENTE: "update_presta_sur_annee_precedente",
  PRESTA_MOIS_PRECEDENT: "update_presta_sur_mois_precedent",
  PRESTA_MOIS_ANNEE_PRECEDENTE: "update_presta_sur_mois_annee_precedente",
  PRESTA_SEMAINE_PRECEDENTE: "update_presta_sur_semaine_precedente",
  PRESTA_SEMAINE_ANNEE_PRECEDENTE: "update_presta_sur_semaine_annee_precedente",

  // TM
  TM_AUJOURDHUI: "update_ticket_moyen_ht_et_ttc_sur_aujourdhui",
  TM_ANNEE: "update_ticket_moyen_ht_et_ttc_sur_annee",
  TM_MOIS: "update_ticket_moyen_ht_et_ttc_sur_mois",
  TM_SEMAINE: "update_ticket_moyen_ht_et_ttc_sur_semaine",
  TM_DYNAMIQUE_HIER: "update_ticket_moyen_ht_et_ttc_dynamique_sur_hier",
  TM_DYNAMIQUE_MEME_JOUR_SP:
    "update_ticket_moyen_ht_et_ttc_dynamique_sur_meme_jour_semaine_precedente",

  TM_ANNEE_PRECEDENTE: "update_ticket_moyen_ht_et_ttc_sur_annee_precedente",
  TM_MOIS_PRECEDENT: "update_ticket_moyen_ht_et_ttc_sur_mois_precedent",
  TM_MOIS_ANNEE_PRECEDENTE:
    "update_ticket_moyen_ht_et_ttc_sur_mois_annee_precedente",
  TM_SEMAINE_PRECEDENTE: "update_ticket_moyen_ht_et_ttc_sur_semaine_precedente",
  TM_SEMAINE_ANNEE_PRECEDENTE:
    "update_ticket_moyen_ht_et_ttc_semaine_annee_precedente",

  NB_TICKETS_AUJOURDHUI: "update_nb_ticket_ht_et_ttc_sur_aujourdhui",
  NB_TICKETS_ANNEE: "update_nb_ticket_ht_et_ttc_sur_annee",
  NB_TICKETS_MOIS: "update_nb_ticket_ht_et_ttc_sur_mois",
  NB_TICKETS_SEMAINE: "update_nb_ticket_ht_et_ttc_sur_semaine",
  NB_TICKETS_DYNAMIQUE_HIER: "update_nb_ticket_ht_et_ttc_dynamique_sur_hier",
  NB_TICKETS_DYNAMIQUE_MEME_JOUR_SP:
    "update_nb_ticket_ht_et_ttc_dynamique_sur_meme_jour_semaine_precedente",

  NB_TICKETS_ANNEE_PRECEDENTE:
    "update_nb_ticket_ht_et_ttc_sur_annee_precedente",
  NB_TICKETS_MOIS_PRECEDENT: "update_nb_ticket_ht_et_ttc_sur_mois_precedent",
  NB_TICKETS_MOIS_ANNEE_PRECEDENTE:
    "update_nb_ticket_ht_et_ttc_sur_mois_annee_precedente",
  NB_TICKETS_SEMAINE_PRECEDENTE:
    "update_nb_ticket_ht_et_ttc_sur_semaine_precedente",
  NB_TICKETS_SEMAINE_ANNEE_PRECEDENTE:
    "update_nb_ticket_ht_et_ttc_semaine_annee_precedente",

  // REGLEMENTS
  REGLE_PAR_JOUR_SUR_SEMAINE: "updateReglementParJourSurSemaine",
  REGLE_PAR_QUART_SUR_JOUR: "updateReglementParQuartSurJour",

  // PRESTA
  PRESTA_CA_EQUIPEMENT_ANNEE: "ca_prestation_par_equipement_sur_annee",
  PRESTA_CA_EQUIPEMENT_MOIS: "ca_prestation_par_equipement_sur_mois",
  PRESTA_CA_EQUIPEMENT_SEMAINE: "ca_prestation_par_equipement_sur_semaine",
  PRESTA_CA_EQUIPEMENT_JOUR: "ca_prestation_par_equipement_sur_jour",

  PRESTA_MOYPAI_ANNEE: "prestation_par_moyen_paiement_sur_annee",
  PRESTA_MOYPAI_MOIS: "prestation_par_moyen_paiement_sur_mois",
  PRESTA_MOYPAI_SEMAINE: "prestation_par_moyen_paiement_sur_semaine",
  PRESTA_MOYPAI_JOUR: "prestation_par_moyen_paiement_sur_jour",

  PRESTA_MOYPAI_ANNEE_PAR_EQUIP:
    "prestation_par_moyen_paiement_sur_annee_par_equipement",
  PRESTA_MOYPAI_MOIS_PAR_EQUIP:
    "prestation_par_moyen_paiement_sur_mois_par_equipement",
  // PRESTA_MOYPAI_SEMAINE_PAR_EQUIP: "prestation_par_moyen_paiement_sur_semaine_par_equipement",
  PRESTA_MOYPAI_JOUR_PAR_EQUIP:
    "prestation_par_moyen_paiement_sur_jour_par_equipement",

  PRESTA_PAR_PROG_PAR_EQUIP_SUR_ANNEE:
    "prestation_par_programme_sur_annee_par_equipement",
  PRESTA_PAR_PROG_PAR_EQUIP_SUR_JOUR:
    "prestation_par_programme_sur_jour_par_equipement",
  PRESTA_PAR_PROG_PAR_EQUIP_SUR_MOIS:
    "prestation_par_programme_sur_mois_par_equipement",
  // PRESTA_PAR_PROG_PAR_EQUIP_SUR_SEMAINE: "prestation_par_programme_sur_semaine_par_equipement",

  PRESTA_PRIX_MOYEN_SUR_ANNEE: "prix_moyen_prestation_sur_annee",
  PRESTA_PRIX_MOYEN_SUR_JOUR: "prix_moyen_prestation_sur_jour",
  PRESTA_PRIX_MOYEN_SUR_MOIS: "prix_moyen_prestation_sur_mois",
  // PRESTA_PRIX_MOYEN_SUR_SEMAINE: "prix_moyen_prestation_sur_semaine",

  PRESTA_PRIX_MOYEN_SUR_ANNEE_PRECEDENTE:
    "prix_moyen_prestation_sur_annee_precedente",
  PRESTA_PRIX_MOYEN_SUR_JOUR_PRECEDENT:
    "prix_moyen_prestation_sur_jour_precedent",
  PRESTA_PRIX_MOYEN_SUR_MOIS_PRECEDENT:
    "prix_moyen_prestation_sur_mois_precedent",

  PRESTA_PRIX_MOYEN_SUR_ANNEE_PAR_EQUIPEMENT:
    "prix_moyen_prestation_sur_annee_par_equipement",
  PRESTA_PRIX_MOYEN_SUR_JOUR_PAR_EQUIPEMENT:
    "prix_moyen_prestation_sur_jour_par_equipement",
  PRESTA_PRIX_MOYEN_SUR_MOIS_PAR_EQUIPEMENT:
    "prix_moyen_prestation_sur_mois_par_equipement",
  PRESTA_PRIX_MOYEN_SUR_SEMAINE_PAR_EQUIPEMENT:
    "prix_moyen_prestation_sur_semaine_par_equipement",

  PRESTA_QTE_LAVAGE_SUR_ANNEE: "qte_lavage_prestation_sur_annee",
  PRESTA_QTE_LAVAGE_SUR_JOUR: "qte_lavage_prestation_sur_jour",
  PRESTA_QTE_LAVAGE_SUR_MOIS: "qte_lavage_prestation_sur_mois",
  PRESTA_QTE_LAVAGE_SUR_SEMAINE: "qte_lavage_prestation_sur_semaine",

  PRESTA_QTE_LAVAGE_SUR_ANNEE_PAR_EQUIPEMENT:
    "qte_lavage_prestation_sur_annee_par_equipement",
  PRESTA_QTE_LAVAGE_SUR_JOUR_PAR_EQUIPEMENT:
    "qte_lavage_prestation_sur_jour_par_equipement",
  PRESTA_QTE_LAVAGE_SUR_MOIS_PAR_EQUIPEMENT:
    "qte_lavage_prestation_sur_mois_par_equipement",
  PRESTA_QTE_LAVAGE_SUR_SEMAINE_PAR_EQUIPEMENT:
    "qte_lavage_prestation_sur_semaine_par_equipement",

  // Vente
  VENTE_CA_EQUIPEMENT_ANNEE: "ca_vente_par_equipement_sur_annee",
  VENTE_CA_EQUIPEMENT_MOIS: "ca_vente_par_equipement_sur_mois",
  VENTE_CA_EQUIPEMENT_SEMAINE: "ca_vente_par_equipement_sur_semaine",
  VENTE_CA_EQUIPEMENT_JOUR: "ca_vente_par_equipement_sur_jour",

  VENTE_QTE_LAVAGE_RECHARGE_SUR_ANNEE: "qte_lavage_et_recharge_vente_sur_annee",
  VENTE_QTE_LAVAGE_RECHARGE_SUR_JOUR: "qte_lavage_et_recharge_vente_sur_jour",
  VENTE_QTE_LAVAGE_RECHARGE_SUR_MOIS: "qte_lavage_et_recharge_vente_sur_mois",
  VENTE_QTE_LAVAGE_RECHARGE_SUR_SEMAINE:
    "qte_lavage_et_recharge_vente_sur_semaine",

  VENTE_QTE_LAVAGE_SUR_ANNEE: "qte_lavage_vente_sur_annee",
  VENTE_QTE_LAVAGE_SUR_JOUR: "qte_lavage_vente_sur_jour",
  VENTE_QTE_LAVAGE_SUR_MOIS: "qte_lavage_vente_sur_mois",
  VENTE_QTE_LAVAGE_SUR_SEMAINE: "qte_lavage_vente_sur_semaine",

  VENTE_QTE_LAVAGE_SUR_ANNEE_PAR_EQUIPEMENT:
    "qte_lavage_vente_sur_annee_par_equipement",
  VENTE_QTE_LAVAGE_SUR_MOIS_PAR_EQUIPEMENT:
    "qte_lavage_vente_sur_mois_par_equipement",
  VENTE_QTE_LAVAGE_SUR_SEMAINE_PAR_EQUIPEMENT:
    "qte_lavage_vente_sur_semaine_par_equipement",
  VENTE_QTE_LAVAGE_SUR_JOUR_PAR_EQUIPEMENT:
    "qte_lavage_vente_sur_jour_par_equipement",

  VENTE_PAR_ARTICLES_SUR_ANNEE: "vente_par_articles_sur_annee",
  VENTE_PAR_ARTICLES_SUR_MOIS: "vente_par_articles_sur_mois",
  VENTE_PAR_ARTICLES_SUR_SEMAINE: "vente_par_articles_sur_semaine",
  VENTE_PAR_ARTICLES_SUR_JOUR: "vente_par_articles_sur_jour",

  VENTE_PAR_MOYPAI_SUR_ANNEE: "vente_par_moyen_paiement_sur_annee",
  VENTE_PAR_MOYPAI_SUR_MOIS: "vente_par_moyen_paiement_sur_mois",
  VENTE_PAR_MOYPAI_SUR_SEMAINE: "vente_par_moyen_paiement_sur_semaine",
  VENTE_PAR_MOYPAI_SUR_JOUR: "vente_par_moyen_paiement_sur_jour",

  VENTE_PAR_MOYPAI_SUR_ANNEE_PAR_EQUIPEMENT:
    "VenteParMoyenPaiementSurAnneeParEquipement",
  VENTE_PAR_MOYPAI_SUR_MOIS_PAR_EQUIPEMENT:
    "VenteParMoyenPaiementSurMoisParEquipement",
  VENTE_PAR_MOYPAI_SUR_SEMAINE_PAR_EQUIPEMENT:
    "VenteParMoyenPaiementSurSemaineParEquipement",
  VENTE_PAR_MOYPAI_SUR_JOUR_PAR_EQUIPEMENT:
    "VenteParMoyenPaiementSurJourParEquipement",

  // Page tickets
  GET_TICKETS: "getTickets",
};

export default jsonURLTotal;
